import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EmailModule from "@/pages/EmailModule";
import LeadsModule from "@/pages/LeadsModule";
import BotModule from "@/pages/BotModule";
import KnowledgeModule from "@/pages/KnowledgeModule";
import Pricing from "@/pages/Pricing";
import Settings from "@/pages/Settings";
import AuthCallback from "@/pages/AuthCallback";
import WidgetDemo from "@/pages/WidgetDemo";
import Analytics from "@/pages/Analytics";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import LegalPage from "@/pages/LegalPage";

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render: handle Google OAuth redirect before normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login mode="login" />} />
      <Route path="/register" element={<Login mode="register" />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/widget-demo" element={<WidgetDemo />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<LegalPage kind="privacy" />} />
      <Route path="/terms" element={<LegalPage kind="terms" />} />
      <Route
        path="/dashboard"
        element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/email"
        element={<ProtectedRoute><EmailModule /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/leads"
        element={<ProtectedRoute><LeadsModule /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/bot"
        element={<ProtectedRoute><BotModule /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/knowledge"
        element={<ProtectedRoute><KnowledgeModule /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/analytics"
        element={<ProtectedRoute><Analytics /></ProtectedRoute>}
      />
      <Route
        path="/dashboard/settings"
        element={<ProtectedRoute><Settings /></ProtectedRoute>}
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
